export default "__VITE_ASSET__Hb7bKbLy__"